import { render, staticRenderFns } from "./PostDialog.vue?vue&type=template&id=51b42254&"
import script from "./PostDialog.vue?vue&type=script&lang=js&"
export * from "./PostDialog.vue?vue&type=script&lang=js&"
import style0 from "./PostDialog.vue?vue&type=style&index=0&id=51b42254&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b42254')) {
      api.createRecord('51b42254', component.options)
    } else {
      api.reload('51b42254', component.options)
    }
    module.hot.accept("./PostDialog.vue?vue&type=template&id=51b42254&", function () {
      api.rerender('51b42254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/PostDialog.vue"
export default component.exports